import { render } from "./Multiplier.vue?vue&type=template&id=eba4be0a"
import script from "./Multiplier.vue?vue&type=script&lang=js"
export * from "./Multiplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__